/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Prism as ReactSyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

import type { ReactNode } from 'react';

const Styles = {
  root: css`
    margin: 22px 0;
  `,
};

type Props = {
  children: ReactNode;
  language: string;
};

function SyntaxHighlighter(props: Props) {
  const { children, language } = props;

  return (
    <div css={Styles.root}>
      <ReactSyntaxHighlighter
        customStyle={{ background: '#354147', borderRadius: 4 }}
        language={language}
        style={tomorrow}
        wrapLongLines={true}
      >
        {children}
      </ReactSyntaxHighlighter>
    </div>
  );
}

export default SyntaxHighlighter;
